<template>
  <div class="pa-3 pb-0">
    <template v-if="activeFieldGrammar.key == 'Title'">
      <v-row class="px-4" v-for="lang in language" :key="lang.key">
        <v-text-field
          v-model="activeFieldGrammar.value[lang.key]"
          v-if="lang.key == 'ja'"
          outlined
          dense
          :error-messages="activeFieldGrammarErrors"
          @input="$v.activeFieldGrammar.value.ja.$touch()"
          @blur="$v.activeFieldGrammar.value.ja.$touch()"
        >
          <template v-slot:label>
            <span class="font-weight-bold mr-1">{{ lang.text }}</span>
            <span class="red--text" v-if="lang.key == 'ja'">*</span>
          </template>
        </v-text-field>
        <v-text-field
          v-model="activeFieldGrammar.value[lang.key]"
          v-else
          outlined
          dense
        >
          <template v-slot:label>
            <span class="font-weight-bold mr-1">{{ lang.text }}</span>
          </template>
        </v-text-field>
      </v-row>
    </template>
    <template v-if="activeFieldGrammar.key == 'ExampleSentence'">
      <!-- <div>
        <strong>音声データ</strong>
        <div class="d-flex mb-5">
          <audio id="Audio" controls :key="keyAudio">
            <source
              :src="activeFieldGrammar.file ? activeFieldGrammar.file.fileUrl : null"
              type="audio/mp3"
            />Your browser does not support the audio element.
          </audio>
          <base-upload type="audio" v-model="activeFieldGrammar.file">
            <span slot="activator">
              <v-btn small class="primary mt-3 ml-2">{{$t('FILE_SELECT')}}</v-btn>
            </span>
          </base-upload>
        </div>
      </div> -->
    </template>
    <template
      v-if="
        activeFieldGrammar.key == 'ExplanatoryText' ||
        activeFieldGrammar.key == 'ExampleSentence' ||
        activeFieldGrammar.key == 'Comment'
      "
    >
      <v-row class="px-4" v-for="lang in language" :key="lang.key">
        <v-textarea
          :spellcheck="false"
          dense
          :auto-grow="true"
          outlined
          :rows="2"
          v-if="lang.key == 'ja'"
          :error-messages="activeFieldGrammarErrors"
          @input="$v.activeFieldGrammar.value.ja.$touch()"
          @blur="$v.activeFieldGrammar.value.ja.$touch()"
          v-model="activeFieldGrammar.value[lang.key]"
        >
          <template v-slot:label>
            <span class="font-weight-bold mr-1">{{ lang.text }}</span>
            <span class="red--text" v-if="lang.key == 'ja'">*</span>
          </template>
        </v-textarea>
        <v-textarea
          :spellcheck="false"
          dense
          :auto-grow="true"
          outlined
          :rows="2"
          v-else
          v-model="activeFieldGrammar.value[lang.key]"
        >
          <template v-slot:label>
            <span class="font-weight-bold mr-1">{{ lang.text }}</span>
          </template>
        </v-textarea>
      </v-row>
    </template>
  </div>
</template>

<script>
import mixin from "@/mixin";
export default {
  name: "Properties",
  mixins: [mixin.ValidateGrammar],
  store: ["activeFieldGrammar"], // Get the form data from Home
  watch: {
    activeFieldGrammar: function () {
      this.$v.$reset();
      this.jaNameKey++;
      this.value++;
    },
    "activeFieldGrammar.file": function () {
      this.keyAudio++;
    },
    "activeFieldGrammar.fileUrl": function () {
      this.keyAudio++;
    },
  },
  data() {
    return {
      language: [
        { text: "日本語", key: "ja" },
        { text: "日本語（かな）", key: "kana" },
        { text: "英語", key: "en" },
        { text: "中国語", key: "cn" },
        { text: "ベトナム語", key: "vn" },
        { text: "ベンガル語", key: "bn" },
        { text: "ポルトガル語", key: "pt" },
      ],
      keyAudio: 0,
    };
  },

  methods: {
    handleCheckValidate() {
      this.$v.$touch();
      console.log(this.$v);
      return this.$v.$anyError;
    },
    showDialogColorChip(index) {
      this.color = this.activeFieldGrammar.options[index].color;
      this.indexColor = index;
      this.dialogColorChips = true;
    },
    deleteOption(option, index) {
      this.$delete(option, index);
    },
    addOption(option) {
      let count = option.length + 1;
      option.push({
        labelEnglish: "Option Label " + count,
        labelJapanese: "Option Label " + count,
        value: "Option " + count,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.properties__optionslist {
  margin-bottom: 5px;
  list-style: none;
  list-style-type: none;
}
.properties__optionsul {
  padding: 0;
}
</style>
<style scoped>
</style>